import { combineReducers } from 'redux';

import fetchContent from './fetch/reducers/content.js';
import fetchErrors from './fetch/reducers/errors.js';
import fetchLoading from './fetch/reducers/loading.js';

import userInfo from './models/reducers/user.js';

import settingErrors from './settings/reducers/errors.js';
import settingLocale from './settings/reducers/locale.js';

const reducers = combineReducers({
	fetchData: combineReducers({
		content: fetchContent,
		errors: fetchErrors,
		loading: fetchLoading
	}),
	models: combineReducers({
		userInfo
	}),
	settings: combineReducers({
		errors: settingErrors,
		locale: settingLocale,
	})
});

/**
 * Export
 */
export default reducers;